import React, { useState, useEffect, createContext } from 'react';
import {
    Typography, Box, Button, Stack, AccordionActions, AccordionSummary,
    Card, CardHeader, Accordion, AccordionDetails, IconButton, TextField,
    InputAdornment, ButtonGroup,
} from '@mui/material';
import { useTournamentContext } from './../../context';
import axios from '../../utils/axios';
import { useParams } from "react-router-dom";
import ClearIcon from '@mui/icons-material/Clear';

import Coach from './coach'

function HomePage() {
    const { tournament, coaches, apiURL } = useTournamentContext();
    const [ search, setSearch ] = useState('')
    const [ status, setStatus ] = useState('')

    const refresh = () => {
        window.dispatchEvent(new CustomEvent("inua-refresh"));
    }

    const getFilteredCoaches = () => coaches
        .sort((a, b) => a.coach?.id - b.coach?.id)
        .filter(p => !!p.coach?.id)
        .filter(p => (p.coach?.name ?? '').toLowerCase().includes(search.toLowerCase()))
        .filter(c => {
            if(status === 'collected' && (!!c.documents_delivered_at || !c.documents_collected_at)){
                return false
            }
            if(status === 'delivered' && !c.documents_delivered_at){
                return false
            }
            if(c.bookings_count + c.participants_count + c.tickets_count < 1){
                return false
            }
            return true
        })

    if(!tournament){
        return (<></>)
    }

    return (<>
      <Stack direction="column" spacing={1} style={{margin: '5px'}} alignItems="stretch">

          <ButtonGroup>
              <Button variant={status === '' ? 'contained' : 'outlined'} onClick={() => setStatus('')}>Всі</Button>
              <Button variant={status === 'collected' ? 'contained' : 'outlined'} color="warning" onClick={() => setStatus('collected')}>Сформовані</Button>
              <Button variant={status === 'delivered' ? 'contained' : 'outlined'} color="success" onClick={() => setStatus('delivered')}>Видані</Button>
          </ButtonGroup>

            <TextField
                fullWidth
                value={search}
                onChange={e => setSearch(e.target?.value ?? '')}
                placeholder={'search-by-name'}
                label="Пошук по імені"
                style={{margin: '5px 0px'}}
                InputProps={{
                  endAdornment: search && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setSearch('')} edge="end">
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            />
        {getFilteredCoaches().map(coach => (
            <Coach
                coach={coach}
                tournament={tournament}
                refresh={refresh}
            />
        ))}
        </Stack>
    </>);
}

export default HomePage;
